export function refresh() {
  return {
    type: 'REFRESH_CUSTOM_WIDGET_VIEW',
  };
}
